__turbopack_context__.v({
  "card": "Categories-module__zKPttq__card",
  "cardBody": "Categories-module__zKPttq__cardBody",
  "catName": "Categories-module__zKPttq__catName",
  "count": "Categories-module__zKPttq__count",
  "desc": "Categories-module__zKPttq__desc",
  "empty": "Categories-module__zKPttq__empty",
  "grid": "Categories-module__zKPttq__grid",
  "illustration": "Categories-module__zKPttq__illustration",
  "zone": "Categories-module__zKPttq__zone",
});
